export default __webpack_public_path__ + "static/media/catwalk_walk.167dc0b0.gif";